import { Icon } from '@/components/Icon';
import { StatePill } from '@/components/primitives';
import { ChannelChip } from '@/components/alerts/ChannelChip';
import { findChannel } from '@/lib/channels';
import type { Alert, NotificationChannel } from '@/types/sturm';

interface AlertFeedRowProps {
  alert: Alert;
  channels: NotificationChannel[];
  workflowName?: string;
  onClick?: () => void;
}

export function AlertFeedRow({ alert, channels, workflowName, onClick }: AlertFeedRowProps) {
  return (
    <div className="feed-row" onClick={onClick}>
      <span className={`feed-dot ${alert.severity}`} />
      <div className="flex1" style={{ minWidth: 0 }}>
        <div className="row gap-8">
          <div className="feed-t">{alert.title}</div>
          <StatePill state={alert.state} by={alert.acknowledgedBy} />
        </div>
        <div className="feed-b">{alert.body}</div>
        <div className="feed-m">
          <span className="row gap-6">
            <Icon name="flow" size={12} />
            {workflowName ?? alert.workflowSlug}
          </span>
          {alert.occurrenceCount > 1 ? (
            <span className="row gap-6">
              <Icon name="layers" size={12} />
              {alert.occurrenceCount} runs grouped
            </span>
          ) : null}
          <span className="row gap-6">
            <Icon name="bell" size={12} />
            {alert.ruleName}
          </span>
          {alert.channelIds.map((id) => (
            <ChannelChip key={id} channel={findChannel(channels, id)} />
          ))}
          <span style={{ marginLeft: 'auto' }}>{alert.at}</span>
        </div>
      </div>
    </div>
  );
}
